import main from "../../images/stages/main.png";
import over from "../../images/stages/ovr.png";
import ozz from "../../images/stages/ozzfest.png";
import meta from "../../images/stages/metatokyo.png";
import dillon from "../../images/stages/dillon.png";
import jerry from "../../images/stages/jerry.png";
import OG from "../../images/stages/og.png";
import merchMarket from "../../images/stages/merchmarket.jpg";
import hex from "../../images/stages/hex.png";
import kraken from "../../images/stages/kraken.png";
import oxArena from "../../images/stages/oxArena.png";
import limewire from "../../images/stages/limewire.png";


export default [
  {
    name: "Ozzfest",
    href: "https://play.decentraland.org/?position=-55%2C55&realm=marvel&island=Ic5t9",
    src: ozz,
    coord: "-55,55",
  },
  {
    name: "Limewire",
    href: "https://play.decentraland.org/?position=-59%2C70&realm=marvel&island=Ic5t9",
    src: limewire,
    coord: "-59,70",
  },
  {
    name: "Dillon Francis Stage",
    href: "https://play.decentraland.org/?position=-66%2C90&realm=marvel&island=Ic88c",
    src: dillon,
    coord: "-66,90",
  },
  {
    name: "Main Stage",
    href: "https://play.decentraland.org/?position=-62%2C63&realm=marvel&island=Ic5t9",
    src: main,
    coord: "-62,63",
  },
  {
    name: "OVER",
    href: "https://play.decentraland.org/?position=-71%2C61&realm=marvel&island=Ic5t9",
    src: over,
    coord: "-71,61",
  },
  {
    name: "OG Stage",
    href: "https://play.decentraland.org/?position=-62%2C87&realm=marvel&island=Ic5t9",
    src: OG,
    coord: "-62,87",
  },
  {
    name: "Jerry Garcia",
    href: "https://play.decentraland.org/?position=-62%2C82&realm=marvel&island=Ic88c",
    src: jerry,
    coord: "-62,82",
  },

  {
    name: "Meta Tokyo",
    href: "https://play.decentraland.org/?position=-54%2C70&realm=marvel&island=Ic5t9",
    src: meta,
    coord: "-54,70",
  },

  {
    name: "The Hex",
    href: "https://play.decentraland.org/?position=-71%2C96&realm=marvel&island=Ic88c",
    src: hex,
    coord: "-71,96",
  },
  {
    name: "Kraken HQ",
    href: "https://play.decentraland.org/?position=-62%2C77&realm=marvel&island=Ic5t9",
    src: kraken,
    coord: "-62,77",
  },
  {
    name: "Ox Arena",
    href: "https://play.decentraland.org/?position=-70%2C57&realm=marvel&island=Ic5t9",
    src: oxArena,
    coord: "-70,57",
  },
  {
    name: "Merch Market",
    href: "https://play.decentraland.org/?position=-68%2C77&realm=marvel&island=Ic88c",
    src: merchMarket,
    coord: "-68,77",
  },
];
